import { parseListDate } from "helpers/parseListDate";
import { CountriesRow } from "./CountriesList.types";

/**
 * Formats a Countries list row, converting date strings to localised display values.
 * @param row - Raw Countries list row from the API.
 * @returns Formatted row with parsed date fields.
 */
export const formatCountriesRow = (
  row: CountriesRow
): { [K in keyof typeof row]: React.ReactNode } => {
  let formattedRow: any = { ...row };

  if (formattedRow.countries__AddDate) {
    formattedRow = {
      ...formattedRow,
      countries__AddDate: parseListDate(formattedRow.countries__AddDate, true),
    };
  }
  if (formattedRow.countries__EditDate) {
    formattedRow = {
      ...formattedRow,
      countries__EditDate: parseListDate(formattedRow.countries__EditDate, true),
    };
  }

  return formattedRow;
};
